/**
 * @type {string}
 * @description Custom attribute for setting the width of the tooltip content.
 */
export const TOOLTIP_CONTENT_WIDTH_ATTRIBUTE = 'tooltip-content-width';

/**
 * @type {string}
 * @description Custom attribute for setting the tooltip position.
 */
export const TOOLTIP_POSITION_ATTRIBUTE = 'tooltip-position';

/**
 * @type {string}
 * @description Custom attribute for setting bound position.
 */
export const BOUND_POSITION_ATTRIBUTE = 'bound-position';

/**
 * @type {string}
 * @description Custom attribute for setting the show dropdown.
 */
export const SHOW_DROPDOWN_ATTRIBUTE = 'show-dropdown';

/**
 * @type {string}
 * @description Custom attribute for setting the keep open.
 */
export const KEEP_OPEN_ATTRIBUTE = 'keep-open';

/**
 * @type {{
 *  TOP: string,
 *  BOTTOM: string,
 *  LEFT: string,
 *  RIGHT: string,
 * }} - Bound positions.
 */
export const BOUND_POSITIONS = {
    TOP: 'top',
    BOTTOM: 'bottom',
    LEFT: 'left',
    RIGHT: 'right',
};

/**
 * Event triggered to hide the tooltip messages.
 * @type {string} - The event name.
 */
export const TRIGGER_HIDE_TOOLTIP_MESSAGES_EVENT = 'trigger-hide-tooltip-messages';

/**
 * @type {{
 *  TOP_RIGHT: string,
 *  TOP_LEFT: string,
 *  BOTTOM_RIGHT: string,
 *  BOTTOM_LEFT: string
 * }} - Tooltip position.
 */
export const TOOLTIP_POSITION = {
    TOP_RIGHT: 'top-right',
    TOP_LEFT: 'top-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_LEFT: 'bottom-left',
};

/**
 * Event triggered to show the help tooltips.
 * @type {string} - The event name.
 */
export const TRIGGER_SHOW_HELP_TOOLTIPS_EVENT = 'trigger-show-help-tooltips';
